module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLBAMAAADKYGfZAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUxpcdTZ3N3u7tPY3Nbg4NPY29XY29PY29PY2wHslwcAAAAIdFJOUwB4CMoZ+VDvOpxMDQAAAIlJREFUeNrt1jEKgDAMBdBUBR1d3O3mqiA4OngBb+E1bFFzbKHFJQQJirjkbwmPtpkauGJ7pNnaGkiSAZl0lBnkslKWxrbFPZRLZJ6yPLRdgi6UTWQHZQV7GjKM5Av2R4RvU6ZMmTJlypTpJ37P5qmSsBKMhI2QvWU5e+lBWcqO4B9sqoK9V7hFn5+pEpbVsQtIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/login/phone.png
// module id = jNOJ
// module chunks = 7